export const DESC = "desc";
export const EMPTY = "";
export const NOT_UNDEFINED = " !== undefined";
export const PERIOD = ".";
export const SPACE = " ";
export const SPACE_DESC = " desc";
